const statuses = require('./statuses');
const commonordermethods = require('../commonordermethods');
const { createOrderItem } = require('../commonordermethods/helpers');
const formatItems = require('../commonordermethods/formatItems')
const addedchargedefinitions = require('./addedchargedefinitions');
const getEventsList = require('../utils/getEventsList')

const LIMIT_DAYS_ALLOW_CREDITS = 90;

const addStatuses = require('../utils/addStatuses');

const EVENTS_MAP = {
	'createdAt': {
		title: 'créée',
		icon: 'plus'
	},
	'verifiedAt': {
		title: 'vérifiée',
		icon: 'ok'
	},
	'compiledAt': {
		title: 'compilée',
		icon: 'cloud'
	},
	'arrivedAt': {
		title: 'arrivée sur place',
		icon: 'home'
	},
	'receivedAt': {
		title: 'reçu',
		icon: 'import'
	},
	'paidAt': {
		title: 'payée',
		icon: 'euro'
	},
	'cancelledAt': {
		title: 'annulée',
		icon: 'remove'
	},
	'tabledAt': {
		title: 'arrivé au guichet',
		icon: 'import'
	},
	'tableDepartedAt': {
		title: 'quitté le guichet',
		icon: 'export'
	},
	'nrValidatedAt': {
		title: 'validation NR',
		icon: 'ok-sign'
	},
}

const methods = Object.assign(commonordermethods, {

	formatAddedItems(params){
    return formatItems(this.added || [], { type: 'items', ...params });
  },
  formatAddedReducedItems(params){
    return formatItems(this.added_reduced || [], { type: 'reduced', ...params });
	},
	getAddedChargeDefinitions(){
		return addedchargedefinitions;
	},

	getAddedChargeDefinition({ code, name }){
    if(typeof code !== 'undefined'){
      return addedchargedefinitions.find(c => c.code === code);
    }
    if(typeof name !== 'undefined'){
      return addedchargedefinitions.find(c => c.name === name);
    }
  },

	allowCredits(){
		const end = new Date(this.distribution_date);
		end.setDate(end.getDate() + LIMIT_DAYS_ALLOW_CREDITS)

		return this.hasAllPaymentsCleared()
			&& (new Date() < end)
	},

	getCreditsValue(){

		if(!this.credits){
			return [];
		}
	
		return this.credits.reduce(
			(acc, credit) => acc += credit,
			0
		)
	},

	getCreditUsed(){
		if (!this.payments || this.payments.length === 0) {
			return 0
		}

		return this.payments.reduce(
			(a,i) => a += i.method === 4 ? i.amount : 0, 
			0
		)
	},

	/*
  	with status 3 (received, the normal situation), 4 (on hold), or 5 (abandonned)
  	we need to charge the payment during distribution closure
	*/

	hasOnlinePayment(){
		return this.payments.some(
			p => p.method === 3 && p.create_success
		);
	},

	getRemovedItems(){

		if(!this.removed){
			return [];
		}

		return this.removed.map(
			item => createOrderItem(item)
		);
	},
  
	getEventsList(exceptions = {}){
		return getEventsList.run.call(this, EVENTS_MAP, exceptions)
	},

	hasAllPaymentsCleared(){
		return !!this.paidAt
			&& this.payments.every(p => p.status > 0) // all payments concluded - failed or success
	},

	hasAddedCharge(code){
		const chargeDefinition = this.getAddedChargeDefinition({ code });
		return this.added_charges
			.map(c => c.code)
			.includes(chargeDefinition.code)
	},
	isCancelled(){
		return !!this.cancelledAt;
	},

	isVerified(){
		return !!this.verifiedAt;
	},

	isCompiled(){
		return this.status >= this.getStatusCodeFromName('compiled');
	},

	allowAddComment(){
		return this.status !== this.getStatusCodeFromName('cancelled');
	},

	allowItemsUpdate(){
		return this.status < 6;
	},

	allowRemove(){
		// status = 0 is remove, status = 1 is cancel, once compiled NOT possible
		return this.status < this.getStatusCodeFromName('compiled');
	},

	allowCancel(){
		return this.status < 2;
	},

	allowValidation(){
    return this.status === 0
  },
	
  allowAddProducts(){
    return this.status === 2 || this.status === 3;
  },
	
	allowPayment(){
		return !this.paidAt
			&& this.status > 0
			&& this.status < 6;
	},

	allowVerify(){
		return this.status === this.getStatusCodeFromName('created');
	},

	isAbandonned(){
		return this.status === this.getStatusCodeFromName('abandonned');
	},

	isOnHold(){
		return this.status === this.getStatusCodeFromName('onhold');
	},

	isDone(){
		return this.status === this.getStatusCodeFromName('done');
	},

	isNR(){
		return this.isOnHold() || this.isAbandonned()
	}
  
});

addStatuses.run(methods, statuses);

module.exports = methods;